<header class="header">
  <h3 class="header__title">
    <div class="titel-contaiter">
      <a routerLink="/home">
        <img src="assets/gls-group-logo.svg" alt="" width="110" style="margin-right: 50px;">
      </a>
      <a href="/" class="title" style="padding-top: 50px; color: #ffffff">XB+ PAX</a>
    </div>
  </h3>
  <div class="menu-items">
    <div class="navbar-controls">
      <div class="navbar-page-controls">
        <button class="btn btn-secondary" *ngIf="setLogoutDisplay && createDisplay && isPaxOrderCreator()" routerLink="/create-orders">New Order</button>
        <button class="btn btn-secondary" *ngIf="currentPath().includes('/my-pickups') || currentPath().includes('/create-order')" routerLink="/my-orders">
          <span class="my-orders-label">My Orders</span>
          <span class="material-symbols-outlined">
            lists
          </span>
        </button>
        <button class="btn btn-secondary" *ngIf="currentPath().includes('/my-orders')" routerLink="/my-pickups">
          <span class="my-pickups-label">My Pickups</span>
          <span class="material-symbols-outlined">
            package_2
          </span>
        </button>
      </div>
      <button class="btn btn-secondary log-out-button" *ngIf="isLoggedIn()" (click)="logout()">
        <span class="logout-button-label">Logout</span>
        <span class="material-symbols-outlined">
          logout
          </span>
      </button>
    </div>
  </div>
</header>
